module.exports = __webpack_public_path__ + "pytorch.9859cfc.png";